import React, { FC, ReactElement } from 'react';

import styles from './preloader-progress-bar.module.scss';

import { SizeFormat } from 'types/ui.interface';
import { Card, Text } from 'views/components';

interface IProgressBar {
  completed: number;
  bgColor: string;
  label: string;
  maxWidth?: SizeFormat;
}

const PreloaderProgressBar: FC<IProgressBar> = (props): ReactElement => {
  const { completed, bgColor, label, maxWidth = '446px' } = props;
  const fillerStyles = {
    width: `${completed}%`,
    backgroundColor: bgColor,
  };

  return (
    <div className={styles.overlay}>
      <Card
        appearance="surface"
        className={styles.container}
        maxWidth={maxWidth}
        maxHeight="80px"
        cardPadding="20px"
      >
        <label className={styles.label}>
          <Text>{label}</Text>
          <Text color="var(--sk-text-subtle)">{`${completed}%`}</Text>
        </label>
        <div className={styles.loader}>
          <div className={styles.filler} style={fillerStyles} />
        </div>
      </Card>
    </div>
  );
};

export { PreloaderProgressBar };
